// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress .value[data-v-117b13a6]{overflow:hidden;position:relative;transition-duration:.5s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);--tw-bg-opacity:1;background-color:#b56576;background-color:rgba(181,101,118,var(--tw-bg-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
